import { GetStaticProps } from 'next'
import React from 'react'

import Page from '@aletheia/common/components/Page'

import { OurFunds } from '../../components/Home'
import { fetchFunds, IFund } from '../../contentful'

type FundsProps = {
  Funds: IFund[]
}

const FundsPage: React.FC<FundsProps> = ({ Funds }) => {
  return (
    <Page
      title="Effective Altruism Funds"
      variant="full"
      showTitle={false}
      showPageTitle={false}
    >
      <OurFunds Funds={Funds} />
    </Page>
  )
}

export default FundsPage

export const getStaticProps: GetStaticProps<FundsProps> = async () => {
  const Funds = await fetchFunds()

  return {
    props: {
      Funds,
    },
    revalidate: 20,
  }
}
